import { IconButton } from "@themis/ui";
import React from "react";
import { PiBellBold } from "react-icons/pi";

import mainStore from "@/stores/Main";

export function NotificationsButton() {
  return (
    <div className="inline-block tw-relative">
      <IconButton
        Icon={PiBellBold}
        color="tertiary"
        size="lg"
        onClick={() => {
          mainStore.notifications.setIsOpen(!mainStore.notifications.isOpen);
        }}
        data-tooltip-id="tooltip"
        data-tooltip-content="Notifications"
        data-tooltip-place="bottom"
      />
      {mainStore.notifications.unreadNotificationsCount > 0 && (
        <div className="tw-absolute tw-bottom-[26px] tw-left-[26px]">
          <div className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-red-500" />
        </div>
      )}
    </div>
  );
}
